import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as TestimonialsSection } from './Section.vue';

export const testimonialContainer = cva(
	'relative h-[769px] w-full sm:h-[950px]',
	{
		variants: {
			variant: {
				dark: 'bg-primary',
				light: 'bg-white'
			}
		}
	}
);

export const testimonialHeader = cva(
	'flex items-center font-matter-sq text-[28px] font-light md:text-[40px]',
	{
		variants: {
			variant: {
				dark: 'text-white',
				light: 'text-primary'
			}
		}
	}
);
export type testimonialContainerVariants = VariantProps<
	typeof testimonialContainer
>;
